
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';






const RoundedBar = (props : any ) => {
    const { fill, x, y, width, height } = props;
  
    // Define the radius for the corners
    const radius = 4;
  
    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          rx={radius}
          ry={radius}
          fill={fill}
        />
      </g>
    );
  };


const PaymentChart = ( { data } : { data : any }) => {


    return <>
        <ResponsiveContainer width="100%" height={200}>
            <BarChart data={data}>
                <Bar dataKey="value" fill="#06C270" barSize={300 / data.length} shape={<RoundedBar />} />
                <XAxis dataKey="short_label" tickLine={false} axisLine={false}/>
                <YAxis tickLine={false} axisLine={false}/>
            </BarChart>
        </ResponsiveContainer>
    </>
}


export default PaymentChart

